<!--
 * @Description: 素材库文件列表管理
 * @Author: hasayake
 * @Date: 2020-05-07 14:48:34
 * @LastEditTime: 2020-07-06 11:25:56
 * @LastEditors: Please set LastEditors
-->

<template>
  <div class="file-list-manage">
    <div
      v-for="(item,index) in fileList"
      :key="item.fileId"
      :class="[
        'file-list-item',
        (item.check||bgCheckList.includes(item.fileId)) ? 'checked' : '',
        item.dirType===1?'disabledCheck':''
      ]"

    >
      <div class="check">
        <el-checkbox @change="val => checkChangeHandler(val, item,index)" :value="item.check" />
      </div>
      <div class="image-box">
        <!-- 文件状态展示 type=1 -->
        <img :src="item.fileThumbnailPath" alt v-if="item.type === 1" @click="openDetailBoxHandler(item)" style="cursor: pointer;" />
        <!-- 文件夹状态 type=2 -->
        <img
          :src="item.hasChild ? folderImgs.have : folderImgs.empty" @click="itemDbClickHandler(item)"
          alt
          v-else
        />
        <!-- 播放按钮 -->
        <img
          v-if="item.docType === 1"
          src="../../assets/images/video-play-icon.png"
          alt @click="openDetailBoxHandler(item)"
          class="video-play"
        />
      </div>

      <div class="name">{{ item.fileName }}</div>
      <div class="down" v-if="item.type === 1" @click="downFilesHandler(item)">
        <i class="el-icon-download"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { downloadFileByStream } from "@/assets/js/api";

export default {
  name: "fileListManage",

  props: {
    fileList: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      folderImgs: {
        have: require("@/assets/images/folder-big-icon.png"),
        empty: require("@/assets/images/folder-big-none-icon.png")
      },
      checkList: [],
      bgCheckList: []
    };
  },

  methods: {
    openDetailBoxHandler(item) {
      this.$emit("playVideo", item);
    },

    // 选中
    checkChangeHandler(val, item,index) {
      if (val) {
        this.checkList.push({
          fileId: item.fileId,
          type: item.type
        });
      } else {
        for (const [idx, i] of this.checkList.entries()) {
          if (i.fileId === item.fileId) {
            this.checkList.splice(idx, 1);
            break;
          }
        }
      }

      this.bgCheckList = this.checkList.map(item => item.fileId);

      this.$emit("checkChange", this.checkList);
    },
    // 文件下载
    downFilesHandler(item) {
      downloadFileByStream(item.fileId).then(res => {
        const a = document.createElement("a");
        const href = URL.createObjectURL(res);
        a.href = href;
        a.download = `${item.fileName}.${item.fileSuffix}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(href);
      });
    },
    // 双击事件
    itemDbClickHandler(item) {
      // 文件夹双击进入
      if (item.type === 2) {
        this.$emit("itemDbClick", {
          name: item.fileName,
          id: item.fileId
        });
      }
    },
    initCheckList(){
      this.checkList=this.fileList.filter(item=>{
        return !!item.check
      })
    }
  },

  mounted() {
    this.initCheckList()
    this.$bus.$on("setEmpty", () => {
      this.checkList = [];
      this.bgCheckList = [];

      this.$emit("checkChange", this.checkList);
    });
  }
};
</script>

<style lang="scss" scoped>
.file-list-manage {
  margin-top: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  flex-wrap: wrap;
  height: calc(100vh - 300px);
  overflow-y: auto;
  .file-list-item {
    width: 120px;
    height: 130px;
    padding: 6px;
    position: relative;
    text-align: center;
    overflow: hidden;

    &:not(.disabledCheck):hover {
      background-color: #f4f4f4;

      .down {
        opacity: 0.5;

        &:hover {
          opacity: 0.8;
        }
      }

      .check {
        visibility: visible;
      }
    }

    &.checked {
      .check {
        visibility: visible;
      }
    }

    .check {
      text-align: right;
      visibility: hidden;
    }

    .name {
      margin-top: 10px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .down {
      width: 100%;
      line-height: 20px;
      background-color: #000;
      cursor: pointer;
      opacity: 0;
      position: absolute;
      left: 0;
      bottom: 0;

      i {
        color: #fff;
      }
    }

    .image-box {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 90px;

      img {
        max-width: 100%;
        max-height: 100%;
        // height: 90px;
      }

      .video-play {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
        width: 20px;
        height: 20px;
        cursor: pointer;
      }
    }
  }

  .file-list-item.checked {
    background-color: #f4f4f4;

    .down {
      opacity: 0.8;
    }
  }
}
</style>
